import GameObject from '../GameObject/GameObject';
import * as PIXI from 'pixi.js';

export default class Component<
    U extends PIXI.Container = PIXI.Container,
    T extends GameObject<U> = GameObject<U>
    > {
    public gameObject: T;
    public container: U;

    [key: string]: any;

    public attach(gameObject: T, params: any): void {
        this.gameObject = gameObject;
        this.container = gameObject.container;

        if (params) {
            for (let key in params) {
                if (key in this) {
                    this[key] =
                        params[key] !== undefined ? params[key] : this[key];
                }
            }
        }

        this.onAttach(this.gameObject, this.container);
    }

    public detach(): void {
        this.onDetach(this.gameObject, this.container);
        this.gameObject = undefined;
        this.container = undefined;
    }

    protected onAttach(gameObject: T, container: U): void {}

    protected onDetach(gameObject: T, container: U): void {}
}
